import { Navigate } from 'react-router-dom';

import McpMemberRoute from './McpMemberRoute';
import ConsentPage from './consent/ConsentPage';
import TopicsPage from './home/TopicsPage';
import AiMomentsPage from './settings/AiMomentsPage';
import CoachingNotesCategoryPage from './settings/CoachingNotesCategoryPage';
import CoachingNotesListPage from './settings/CoachingNotesListPage';
import ConnectAiPage from './settings/ConnectAiPage';
import SettingsShell from './settings/SettingsShell';

import type { RouteObject } from 'react-router-dom';

// Children of the /m Layout route (contracts §7). Consent is not wrapped:
// unflagged members must reach it to see "not available".
export const mcpMemberRoutes: RouteObject[] = [
  {
    children: [
      { element: <Navigate to="coaching-notes" replace />, index: true },
      { element: <AiMomentsPage />, path: 'ai-moments' },
      { element: <ConnectAiPage />, path: 'connect-ai' },
      {
        element: <CoachingNotesCategoryPage />,
        path: 'coaching-notes/:category',
      },
      { element: <CoachingNotesListPage />, path: 'coaching-notes' },
    ],
    element: (
      <McpMemberRoute>
        <SettingsShell />
      </McpMemberRoute>
    ),
    path: 'settings',
  },
  { element: <ConsentPage />, path: 'connect/authorize' },
  {
    element: (
      <McpMemberRoute>
        <TopicsPage />
      </McpMemberRoute>
    ),
    path: 'topics',
  },
];
